// Desc: Admin Overview page
// import { useNavigate } from "react-router-dom";
import { httprequest } from "../../../../data/api";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import { Tooltip } from "@mui/material";
import Table from "../../../../components/Table/Table";
import { TableSearch } from "../../../../components/Table/TableActions";
import Badge from "../../../../components/Badge";
import { Icon } from "@iconify/react";
import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";
import { useNavigate } from "react-router-dom";
import { StructureType } from "../../../../utils/DropDown";
import useWindowSize from "../../../../hooks/useWindow";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const ALL_INVOICES = "/api/v1/invoices";

const SavedInvoices = () => {
  const navigate = useNavigate();
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [allSavedInvoices, setAllSavedInvoice] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [isDeleting, setinvoiceDeleting] = useState(false);
  const [isReloadLoading, setIsReloadLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);

  /** @type {number} The current window width */
  const width = useWindowSize();
  /** @type {boolean} Flag indicating if the current view is mobile (width < 600px) */
  const isMobile = width < 600;

  /**
   * Closes the delete confirmation modal
   */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
   * Toggles the delete confirmation modal and sets the current row to be deleted
   * @param {Object} row - The invoice row to potentially delete
   */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  /**
   * Fetches all terms for a given session
   * @param {string} Session_ID - The ID of the session to get terms for
   */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
   * Fetches all saved invoices for a selected term
   * @param {string} aselectedTerm - The ID of the term to get invoices for
   */
  const getSavedinvoices = (aselectedTerm) => {
    setIsReloadLoading(true);
    httprequest
      .get(`${ALL_INVOICES}?term_id=${aselectedTerm}`)
      .then((res) => {
        setIsReloadLoading(false);
        setAllSavedInvoice(res?.data?.data?.invoices?.filter((invoice) => invoice?.status.toLowerCase() === "saved"));
        setSearchResult(res?.data?.data?.invoices?.filter((invoice) => invoice?.status.toLowerCase() === "saved"));
      });
    // .catch(() => {});
  };

  /**
   * Fetches all available sessions
   * @async
   */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
   * Handles deleting an invoice item
   */
  const handleDeleteItem = () => {
    setinvoiceDeleting(true);
    httprequest.delete(`${ALL_INVOICES}/${currentRow?.id}`).then(() => {
      setinvoiceDeleting(false);
      toast.success("Invoice Deleted Successfully");
      getSavedinvoices(aselectedTerm);
      handleCloseDeleteModal();
    }).catch((err) => {
      setinvoiceDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /** @type {Object|null} The active term in the current session */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
   * Handles session change event
   * @param {Event} e - The change event
   */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
   * Handles term change event
   * @param {Event} event - The change event
   */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getSavedinvoices(selectedTermId);
  };

  /**
   * @type {Array} Columns configuration for the data table
   */
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Name</p>}
          {row?.invoice_name}
        </>
      )
    },
    {
      name: "Structure",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Structure</p>}
          <span className="class_div">
            {row?.structure_type}
          </span>
        </>
      )
    },
    {
      name: "To",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">To</p>}
          {row?.to?.map((receive) => (
            <span className="class_div" key={receive?.id}>
              {receive?.name}
            </span>
          )) || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.classes?.length
            ? row.classes?.map((clss) => clss?.name).join(" | ")
            : "--/--"}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row?.created_at.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row?.total || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column" }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => navigate(`/payment/preview-invoice/${row?.id}`)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          {row?.status === "saved" ? (
            <button
              className="table-action-icon"
              onClick={() => navigate(`/payment/edit-invoice/${row?.id}`)}
            >
              <Icon icon="heroicons:pencil-square-solid" />
            </button>
          ) : (
            null
          )}
          {row?.status === "saved" ? (
            <button
              className="table-action-icon delete-icon"
              onClick={() => handleDeleteModal(row)}
            >
              <Icon icon="mingcute:delete-2-line" />
            </button>
          ) : (
            null
          )}
        </div>
      )
    }
  ];

  /**
   * Filters invoices based on search input
   * @param {Event} e - The input change event
   */
  const handleSearchInvoice = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? allSavedInvoices.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : allSavedInvoices;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.invoice_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.structure
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.class?.name
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
   * Handles filter change for invoice structure type
   * @param {Event} e - The change event
   */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter guardians based on status when the filter is applied
    const filteredByStatus = value
      ? allSavedInvoices.filter((data) => data?.structure_type.toLowerCase() === value.toLowerCase())
      : allSavedInvoices;

    setSearchResult(filteredByStatus);
  };

  // On mount renders all classes
  useEffect(() => {
    getAllSessions();
    getAllTerms();
  }, []);

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      getSavedinvoices(active_term_session?.id);
    }
  }, [active_term_session]);

  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <>
      {isReloadLoading ? (
        <div className="container-left">
          <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
        </div>
      ) : (
        <div className="flex gap-10 align-items-end margin-top-5">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            <SelectGroup
              children={
                <select onChange={handleFilterChange}>
                  <option value="">---Select---</option>
                  {StructureType?.map((data) => {
                    return (
                      <option key={data?.key} value={data?.key}>
                        {data?.text}
                      </option>
                    );
                  })}
                </select>
              }
            />
          </div>
          {/* <Tooltip title="This will reload all saved invoices" arrow>
            <div className=" cursor-pointer">
              {isReloadLoading ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" />
                : <Icon onClick={() => getSavedinvoices(aselectedTerm)} icon="ooui:reload" width="20" height="20" />}
            </div>
          </Tooltip> */}
        </div>
      )}

      <div className="page-content margin-top-13">
        <>
          <Table
            data={searchResult}
            columns={columns}
            subHeader={true}
            pagination
            subHeaderComponent={
              <div className="action_div">
                <TableSearch
                  placeholder="Search here..."
                  searchTableFunc={handleSearchInvoice}
                />
              </div>}
          />
        </>
      </div>
      {/* Delete Modal */}
      <Modal
        title="Delete Invoice"
        subtitle={
          <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.invoice_name}</span>. Implication is that the students and class teacher wont have access to this Invoice anymore.`
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Delete invoice" buttonSize="full" color="btndefault" onClick={handleDeleteItem} isLoading={isDeleting} />
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
    </>
  );
};

export default SavedInvoices;
